/**
 * 管理员操作日志：一级/二级模块与后端 model_id 对齐。
 * labelKey 优先与侧边栏 nav-menu 的 menu.* 一致；无对应菜单项时用 noticeManage.adminOp* / sensitiveFileScanning.* 等。
 */
export const models = [
  {
    model_id: 1,
    labelKey: 'noticeManage.adminOpFirst.account',
    models: [
      { model_id: 1, labelKey: 'noticeManage.adminOpSecond.login' },
      { model_id: 2, labelKey: 'menu.inviteAdmin' },
      { model_id: 3, labelKey: 'noticeManage.adminOpSecond.becomeAdmin' },
      { model_id: 4, labelKey: 'noticeManage.adminOpSecond.deleteAdmin' },
      { model_id: 5, labelKey: 'noticeManage.adminOpSecond.transferSuperAdmin' },
      { model_id: 6, labelKey: 'noticeManage.adminOpSecond.exitTeam' },
    ],
  },
  {
    model_id: 2,
    labelKey: 'menu.terminalManage',
    models: [
      { model_id: 7, labelKey: 'noticeManage.adminOpSecond.createGroup' },
      { model_id: 8, labelKey: 'noticeManage.adminOpSecond.adjustTerminalGroup' },
      { model_id: 9, labelKey: 'noticeManage.adminOpSecond.changeTerminalPassword' },
      { model_id: 10, labelKey: 'noticeManage.adminOpSecond.deleteTerminal' },
      { model_id: 11, labelKey: 'noticeManage.adminOpSecond.deleteAndBlacklistTerminal' },
    ],
  },
  {
    model_id: 3,
    labelKey: 'noticeManage.adminOpFirst.messageCommand',
    models: [
      { model_id: 12, labelKey: 'noticeManage.adminOpSecond.messagePush' },
      { model_id: 13, labelKey: 'noticeManage.adminOpSecond.completeProfile' },
      { model_id: 14, labelKey: 'noticeManage.adminOpSecond.shutdown' },
      { model_id: 15, labelKey: 'noticeManage.adminOpSecond.reboot' },
      { model_id: 16, labelKey: 'noticeManage.adminOpSecond.oneClickUpgrade' },
      { model_id: 17, labelKey: 'noticeManage.adminOpSecond.fullExam' },
      { model_id: 18, labelKey: 'noticeManage.adminOpSecond.quickScan' },
      { model_id: 19, labelKey: 'noticeManage.adminOpSecond.fullDiskScan' },
      { model_id: 20, labelKey: 'noticeManage.adminOpSecond.remindUninstallSoft' },
      { model_id: 21, labelKey: 'noticeManage.adminOpSecond.startUninstallSoft' },
      { model_id: 22, labelKey: 'menu.softwareDispatcher' },
      { model_id: 23, labelKey: 'menu.fileDispatch' },
      { model_id: 24, labelKey: 'noticeManage.adminOpSecond.optimizeBoot' },
      { model_id: 25, labelKey: 'noticeManage.adminOpSecond.cancelOptimizeBoot' },
      { model_id: 26, labelKey: 'noticeManage.adminOpSecond.trustBootItem' },
      { model_id: 27, labelKey: 'noticeManage.adminOpSecond.cancelTrustBootItem' },
      { model_id: 36, labelKey: 'menu.baselineScan' },
      { model_id: 37, labelKey: 'noticeManage.adminOpSecond.disableEnableUser' },
    ],
  },
  {
    model_id: 4,
    labelKey: 'menu.protectionStrategySetting',
    models: [
      { model_id: 28, labelKey: 'noticeManage.adminOpSecond.scheduledExam' },
      { model_id: 29, labelKey: 'noticeManage.adminOpSecond.scheduledAntivirus' },
      { model_id: 30, labelKey: 'noticeManage.adminOpSecond.policyTrafficMonitor' },
      { model_id: 32, labelKey: 'noticeManage.adminOpSecond.alertMonitorSettings' },
      { model_id: 33, labelKey: 'menu.vulnerabilityFix' },
      { model_id: 35, labelKey: 'menu.baselineScan' },
      { model_id: 38, labelKey: 'noticeManage.adminOpSecond.systemProtectAndScan' },
    ],
  },
  {
    model_id: 5,
    labelKey: 'menu.safeProtection',
    models: [
      { model_id: 39, labelKey: 'menu.protectionStrategySetting' },
      { model_id: 51, labelKey: 'menu.fileWhitelist' },
    ],
  },
  {
    model_id: 6,
    labelKey: 'menu.softwareManage',
    models: [
      { model_id: 43, labelKey: 'menu.softwareDisabled' },
      { model_id: 45, labelKey: 'menu.processControl' },
      { model_id: 47, labelKey: 'menu.genuineSoftwareAuth' },
    ],
  },
  {
    model_id: 7,
    labelKey: 'menu.dataSecurity',
    models: [
      { model_id: 46, labelKey: 'menu.screenWatermark' },
      { model_id: 34, labelKey: 'menu.usbPolicy' },
      { model_id: 48, labelKey: 'sensitiveFileScanning.sensitiveWordConfig' },
      { model_id: 49, labelKey: 'menu.outboundControlStrategy' },
      { model_id: 50, labelKey: 'menu.terminalFileOutboundApproval' },
      { model_id: 68, labelKey: 'noticeManage.adminOpSecond.usbDeviceApproval' },
    ],
  },
  {
    model_id: 8,
    labelKey: 'menu.internetProtection',
    models: [
      { model_id: 31, labelKey: 'menu.domainAccessRestriction' },
      { model_id: 60, labelKey: 'menu.ipAccessRestriction' },
      { model_id: 30, labelKey: 'menu.terminalTrafficStatus' },
      { model_id: 65, labelKey: 'menu.remoteLoginAuth' },
    ],
  },
  {
    model_id: 10,
    labelKey: 'menu.settings',
    models: [
      { model_id: 52, labelKey: 'menu.assetRegistration' },
      { model_id: 53, labelKey: 'noticeManage.adminOpSecond.teamSettings' },
    ],
  },
  {
    model_id: 11,
    labelKey: 'menu.cascadeCenter',
    models: [
      { model_id: 54, labelKey: 'menu.cascadeBranchOverview' },
      { model_id: 55, labelKey: 'menu.cascadeManage' },
      { model_id: 56, labelKey: 'menu.cascadeApproval' },
    ],
  },
  {
    model_id: 12,
    labelKey: 'menu.logAudit',
    models: [
      { model_id: 57, labelKey: 'noticeManage.adminOpSecond.fetchTroubleshootLog' },
      { model_id: 58, labelKey: 'noticeManage.adminOpSecond.deleteTroubleshootLog' },
      { model_id: 59, labelKey: 'noticeManage.adminOpSecond.changeDebugMode' },
    ],
  },
  {
    model_id: 13,
    labelKey: 'menu.responseHandle',
    models: [
      { model_id: 61, labelKey: 'noticeManage.adminOpSecond.isolateTerminalChange' },
      { model_id: 62, labelKey: 'noticeManage.adminOpSecond.fetchTerminalProcess' },
      { model_id: 63, labelKey: 'noticeManage.adminOpSecond.detectWeakPassword' },
      { model_id: 64, labelKey: 'noticeManage.adminOpSecond.closeTerminalProcess' },
    ],
  },
]
